import { isBoolean as t } from "../../utils/types.js";
const a = {
  visible: Boolean,
  title: {
    type: String,
    default: ""
  },
  message: {
    type: String,
    default: ""
  },
  width: {
    type: [String, Number]
  },
  dialogClass: {
    type: String,
    default: ""
  },
  showClose: {
    type: Boolean,
    default: !0
  },
  showConfirmButton: {
    type: Boolean,
    default: !0
  },
  zIndex: {
    type: Number
  },
  showCancelButton: {
    type: Boolean,
    default: !1
  },
  confirmButtonText: {
    type: String,
    default: "OK"
  },
  cancelButtonText: {
    type: String,
    default: "Cancel"
  },
  buttonCenter: Boolean,
  draggable: {
    type: Boolean,
    default: !1
  },
  callback: Function
}, l = {
  confirm: () => !0,
  cancel: () => !0,
  close: () => !0,
  "update:visible": (e) => t(e)
};
export {
  a as messageBoxProps,
  l as messageEmits
};
